import { createSlice } from '@reduxjs/toolkit';
import { updateCart } from '../utils/cartUtils';

// Re-run updateCart on load so carts saved under older pricing rules (USD,
// flat shipping, 15% tax) are recalculated with the current NTD rules.
const initialState = localStorage.getItem("cart") ? updateCart(JSON.parse(localStorage.getItem("cart"))) : {cartItems: [], shippingAddress: {}, shippingMethod: "", paymentMethod: "PayPal" };


const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addToCart: (state, action) => {
      const item = action.payload;

      const existItem = state.cartItems.find((x) => x._id === item._id);

      if (existItem) {
        state.cartItems = state.cartItems.map((x) => x._id === existItem._id ? item : x);
      } else {
        state.cartItems = [...state.cartItems, item];
      }
      
      return updateCart(state);
    },
    removeFromCart: (state, action) => {
      state.cartItems = state.cartItems.filter((x) => x._id !== action.payload);
      
      return updateCart(state);
    },
    saveShippingAddress: (state, action) => {
      state.shippingAddress = action.payload;
      return updateCart(state);
    },
    saveShippingMethod: (state, action) => {
      state.shippingMethod = action.payload;
      return updateCart(state);
    },
    savePaymentMethod: (state, action) => {
      state.paymentMethod = action.payload;
      return updateCart(state);
    },
    clearCartItems: (state, action) => {
      state.cartItems = [];
      return updateCart(state);
    },
    resetCart: (state)  => (state = initialState)
  },
});

export const { addToCart, removeFromCart, saveShippingAddress, saveShippingMethod, savePaymentMethod, clearCartItems, resetCart } = cartSlice.actions;

export default cartSlice.reducer;